import { useEffect, useRef, useState } from 'react';
import MasterComponentWraper from '../../Backend/MasterComponentWraper';
import NavigationHeder from '../../Navigations/NavigationHeder';
import AgGridNew from '../../grid/ag/ag-grid-new';
import { getLabelFromDropdown, getNewValue, gridLinkValueFormat, generateBaseUrl } from '../../grid/ag/commonFunctions/GridCommonFunctions';
import Settings from '../../../inc/Settings';
import GridResponsiveDropdownMenu from '../../grid/GridResponsiveDropdownMenu';
import DatepickerFunctions from '../../../inc/DatepickerHelper';
import SimpleDropdown from '../../grid/ag/cellEditor/SimpleDropdown';
import Api from '../../../inc/Api';
import { getPopupMessageBasedOnStatus, exportToXlsx } from '../../../inc/Validation';
import { connect } from 'react-redux';
import Helper from '../../../inc/Helper';
import PayloadDetails from './PayloadDetails';
import PaginatedDropdown from '../../Forms/PaginatedDropdown';
import { transformObjectIntegrationLogs } from '../../../inc/TransformerFunctions';
import OverlayLoader from '../../Loading/OverlayLoader';

let integrationGridApiLynkaz = null;
let currentSearchTermSource = '';
let currentSearchTermTarget = '';

const IntegrationMonitor = ({ auth }) => { 
    const [isEnableErrorDetailsLynkaz, setIsEnableErrorDetailsLynkaz] = useState(true);
    const [isEnableApiDetailsLynkaz, setIsEnableApiDetailsLynkaz] = useState(true);

    const [openPayloadDetailsPopup, setOpenPayloadDetailsPopup] = useState(false);
    const [isEnabledLynkazForm, setIsEnabledLynkazForm] = useState(false);

    const [gridForceRender, setGridForceRender] = useState(1);
    const [dataQueueParams, setDataQueueParams] = useState({});
    const [dataQueueObject, setDataQueueObject] = useState([]); 

    const sourceDataRef = useRef([]);
    const targetDataRef = useRef([]);

    const [exportLoading, setExportLoading] = useState(false);
    const totalRecords = useRef(0);

    useEffect(() => {
        if (
            dataQueueParams?.source &&
            dataQueueParams?.target &&
            dataQueueParams?.source == dataQueueParams?.target
        ) {
            Helper.alert('Source & Target cannot be the same', 'error');
        }
    }, [dataQueueParams.source, dataQueueParams.target]);

    const gridColumnHeadersIntegration = [
        { field:'document_number', minWidth: 200, valueFormatter: (params) => params.value ?? '-', headerName:'Document number', editable: false },
        { field:'api_response', cellRenderer: (params) => gridLinkValueFormat(params, 'View api response'), headerName:'Api response', editable: false }, 
        { field:'tenant', headerName:'Tenant', editable: false }, 
        { field:'entity', headerName:'Entity', editable: false }, 
        { field:'enqueued_at', filter: 'agDateColumnFilter', valueFormatter: (params) => params.value ? DatepickerFunctions.convertDateTimeFromDataBase(params.value) : '-', headerName:'Enqueued at', editable: false }, 
        { field:'dequeued_at', filter: 'agDateColumnFilter', valueFormatter: (params) => params.value ? DatepickerFunctions.convertDateTimeFromDataBase(params.value) : '-', headerName:'Dequeued at', editable: false }, 
        {
            field: 'status',
            headerName: 'Status',
            editable: false, 
            isAllowZero:true,
            cellEditor: SimpleDropdown,
            minWidth:180,
            cellEditorParams: {
                values: Settings.enumStatusDataQueue
            },
            cellDataType:false,
            valueFormatter: (params) => getLabelFromDropdown(params)
        } 
    ];

    const CronJobActionBtns = () => { 
        const DropdownItems = [
            {
                id: 1,
                fontawesomeIcon: 'fa-solid fa-pause',
                name: 'Pause',
                disableBeforeClick: !isEnabledLynkazForm,
                onClick: onPauseCronJobClick,
                customIcon: true
            }, 
            {
                id: 2,
                fontawesomeIcon: 'fa-solid fa-play',
                name: 'Resume',
                disableBeforeClick: isEnabledLynkazForm,
                onClick: onResumeCronJobClick,
                customIcon: true 
            }, 
            {
                id: 3,
                fontawesomeIcon: 'fa-solid fa-circle-info',
                name: 'Api details',
                disableBeforeClick: isEnableApiDetailsLynkaz,
                onClick: onClickApiDetails,
                customIcon: true 
            }, 
            {
                id: 4,
                fontawesomeIcon: 'fa-solid fa-rotate-right',
                name: 'Retry',
                disableBeforeClick: isEnableErrorDetailsLynkaz,
                onClick: onClickRetry,
                customIcon: true
            }
        ];

        return ( <GridResponsiveDropdownMenu dropdownItems={DropdownItems} /> )
    };

    const ReFetchApiActionBtns = () => {
        return (
            <div className='d-flex me-3'>
                <button onClick={executeRefreshDataQueue} className='rs_h_controller'>
                    <i class="fa-solid fa-arrows-rotate"></i>
                    <span>Refresh</span>
                </button>  
            </div>
        )
    };

    const commonDataMap = (item) => {
        return {
            text: `${item.app_name}`,
            id: item.app_id
        };
    };

    const onClickApiDetails = () => {
        const selectedNode = integrationGridApiLynkaz?.api?.getSelectedRows()

        if (selectedNode?.length > 0) {
            setDataQueueObject(selectedNode); 
            setOpenPayloadDetailsPopup(true);
        } else {
            setDataQueueObject([]); 
            setOpenPayloadDetailsPopup(false);
        }
    };

    const onClickRetry = () => {
        let selectedNode = integrationGridApiLynkaz?.api?.getSelectedRows();
        if(selectedNode?.length > 0) { onRetryApiClick(selectedNode[0]) };
    };

    const onRetryApiClick = async (apiNode) => {
        try { 
            let api = Api;
            api.setUserToken();

            const res = await api
                .axios()
                .post(
                    Settings.apiUrl + `/migrate/v1/data_queue/retry`,
                    {
                        tenant_id: apiNode?.tenant,
                        queue_id: apiNode?.queue_id, 
                        entity: apiNode?.entity
                    }
                );

                if (res?.status === 200) {
                    setTimeout(() => { 
                        integrationGridApiLynkaz?.api?.refreshServerSide({ purge: true });  
                        integrationGridApiLynkaz?.api?.deselectAll();
                    }, 100);
                    
                    Helper.alert(res?.data?.message || 'Task pushed to queue again successfully', 'success');
                } else {
                    Helper.alert(res?.data?.message, 'error')
                }
        } catch (error) {
            getPopupMessageBasedOnStatus(error);
        }
    };

    const executeRefreshDataQueue = () => {
        integrationGridApiLynkaz?.api?.refreshServerSide({ purge: true });  
        integrationGridApiLynkaz?.api?.deselectAll();
    };
    
    const onPauseCronJobClick = async () => { 
        try { 
            let api = Api;
            api.setUserToken();

            const res = await api
                .axios()
                .post(
                    Settings.apiUrl + `/migrate/v1/pause-task/${auth?.user?.tenant_id}/`,
                    { entity_type: "PAYMENT_TERM" }
                );

                if (res) {
                    setTimeout(() => {
                        integrationGridApiLynkaz?.api?.refreshServerSide({ purge: true });  
                        integrationGridApiLynkaz?.api?.deselectAll();
                    }, 100);
                    
                    Helper.alert(res?.data?.status || 'Cron job is paused successfully', 'success');
                }
        } catch (error) {
            getPopupMessageBasedOnStatus(error);
        }
    };

    const onResumeCronJobClick = async () => {
        try { 
            let api = Api;
            api.setUserToken();

            const res = await api
                .axios()
                .post(
                    Settings.apiUrl + `/migrate/v1/resume-task/${auth?.user?.tenant_id}/`,
                    { entity_type: "PAYMENT_TERM" } 
                );
                
                if (res) {
                    setTimeout(() => {
                        integrationGridApiLynkaz?.api?.refreshServerSide({ purge: true });  
                        integrationGridApiLynkaz?.api?.deselectAll();
                    }, 100);

                    Helper.alert(res?.data?.status || 'Cron job is resumed successfully', 'success');
                }
        } catch (error) {
            getPopupMessageBasedOnStatus(error);
        }
    };

    const handleFetchDataLynkaz = (response) => { 
        if(response?.data) {
            setIsEnabledLynkazForm(response?.data?.enabled); 
            totalRecords.current = response?.data?.count;
        };

        return {
            rowData: response?.data?.results?.map((item) => ({
                ...item,
                gridId: `${Date.now()}_${getNewValue()}`
            })),
            rowCount: response?.data?.count || 0
        }
    };

    const handleRowSelection = (params, setIsEnableApiDetails, setIsEnableErrorDetails) => {
        let selectedGridObject = params?.api?.getSelectedRows()[0];
        
        setIsEnableApiDetails(!selectedGridObject);
        setIsEnableErrorDetails(!selectedGridObject);
    };
    
    const onGridCellClick = (params) => {
        if(params.colDef.field === 'api_response') {
            setDataQueueObject([{ api_response: params?.data?.api_response, apiResponsePreview: true }]);
            setOpenPayloadDetailsPopup(true);
        };
    };

    const onRowSelectionOfLynkaz = (params) => {
        handleRowSelection(params, setIsEnableApiDetailsLynkaz, setIsEnableErrorDetailsLynkaz);
    };

    const refreshParentGrid = () => {
        integrationGridApiLynkaz?.api?.refreshServerSide({ purge: true });
        integrationGridApiLynkaz?.api?.deselectAll(); 
    };

    const disableApiCalls = !(dataQueueParams?.source && dataQueueParams?.target && dataQueueParams?.source !== dataQueueParams?.target);

    const getTransformedObjForExport = (data) => transformObjectIntegrationLogs(data, Settings.enumStatusDataQueue);

    const exportData = async () => { 
        if(disableApiCalls) return;

        setExportLoading(true);

        const apiUrl = Settings.apiAppUrl + `/data-queue`;
        const params = `&source=${dataQueueParams?.source}&target=${dataQueueParams?.target}&ordering='-retry_datetime'`;
        let pageSize = totalRecords.current;

        let pagination = true;
        let defaultAdvanceFilterObj = false;

        const baseUrl = generateBaseUrl({ gridObj: integrationGridApiLynkaz, apiUrl, params, pagination, defaultAdvanceFilterObj, pageSize });
        await exportToXlsx({ url: baseUrl, columns: (gridColumnHeadersIntegration), fileName: "all_integration_logs", additionalFunction: getTransformedObjForExport });
        
        setExportLoading(false);
    };

    return (
        <div className='container-fluid'>
            {exportLoading ? <OverlayLoader /> : null}
            <NavigationHeder hideMoreBtn={true} backUrl='/system-integration' title={'System Integration Monitor'} />
            
            <div className="row">
                <div className='col-lg-3'>  
                    <PaginatedDropdown
                        options={[]} 
                        pagination={true}
                        apiUrl={Settings.apiAppUrl+'/details'} 
                        currentSearchTerm={currentSearchTermSource}
                        allDataRef={sourceDataRef}
                        mapFunction={commonDataMap}
                        reRenderRequired={true}
                        placeHolder={"Select source"} 
                        label={'Source'}
                        id="source"
                        onChange={(evt) => {
                            setDataQueueParams((prevState) => {
                                return {
                                    ...prevState,
                                    source: evt.target.value
                                }
                            })
                            setGridForceRender(prevState => prevState + 1);
                        }}
                        value={dataQueueParams?.source}
                    />
                </div>

                <div className='col-lg-3'>  
                    <PaginatedDropdown
                        options={[]} 
                        pagination={true}
                        apiUrl={Settings.apiAppUrl+'/details'} 
                        currentSearchTerm={currentSearchTermTarget}
                        allDataRef={targetDataRef}
                        mapFunction={commonDataMap}
                        reRenderRequired={true}
                        placeHolder={"Select target"} 
                        label={'Target'}
                        id="target"
                        onChange={(evt) => {
                            setDataQueueParams((prevState) => {
                                return {
                                    ...prevState,
                                    target: evt.target.value
                                }
                            })
                            setGridForceRender(prevState => prevState + 1);
                        }}
                        value={dataQueueParams?.target}
                    />
                </div> 
            </div>

            <div className='row'>
                <div className='col-12 mb-3'>
                    <div className='to_integration_grid'>
                        <AgGridNew
                            key={gridForceRender}
                            fetchData={handleFetchDataLynkaz}
                            onGridReady={(params) => integrationGridApiLynkaz = params}
                            apiUrl={Settings.apiAppUrl + `/data-queue`}
                            additionalParams={`&source=${dataQueueParams?.source}&target=${dataQueueParams?.target}&ordering='-retry_datetime'`}
                            filterAdditionalParams={`&source=${dataQueueParams?.source}&target=${dataQueueParams?.target}&ordering='-retry_datetime'`}
                            rowType={'single'}
                            paginationPageSize={100}
                            onCellClicked={onGridCellClick}
                            onSelectionChanged={onRowSelectionOfLynkaz}
                            returnApiCondition={disableApiCalls}
                            columnDefs={gridColumnHeadersIntegration} 
                            pagination={true} 
                            afterDeleteBtns={<CronJobActionBtns />}
                            hideAddBtn={true}
                            hideDeleteBtn={true}
                            rightAllBtns={
                                <div className="d-flex align-items-center gap-2 me-3">
                                    <div className="import_sample_template">
                                        <button onClick={exportData} className="d-flex align-items-center gap-1">
                                            <img
                                                className="img-fluid"
                                                src="/images/icons/excel-logo.svg"
                                                alt="excel-logo"
                                                style={{ height: "16px" }}
                                            />
                                            Export
                                        </button>
                                    </div>

                                    <ReFetchApiActionBtns />
                                </div>
                            }
                            height={500}   
                            gridId={"to_integration_grid_class"}
                        />
                    </div>
                </div>
            </div>

            {openPayloadDetailsPopup && <PayloadDetails refreshParentGrid={refreshParentGrid} apiDetailsPayload={dataQueueObject[0]} setClosePopupViewModal={setOpenPayloadDetailsPopup} />}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
};

export default connect(mapStateToProps) (MasterComponentWraper(IntegrationMonitor));